import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M22.633 22.118a.97.97 0 0 1-.971.973H10.414a.97.97 0 0 1-.972-.973V12.07c2.949-.01 9.827-.01 13.191 0zM13.609 6.915a.225.225 0 0 1-.097.301.225.225 0 0 1-.301-.097l-1.422-2.771a.224.224 0 0 1 .4-.204zm5.179.118a.22.22 0 0 1-.307.08.22.22 0 0 1-.08-.304l1.557-2.697a.22.22 0 0 1 .305-.081.22.22 0 0 1 .082.304zm7.279 12.358a1.416 1.416 0 1 1-2.834 0v-6.197c0-.783.634-1.416 1.418-1.416.782 0 1.416.633 1.416 1.416zm-17.234 0a1.417 1.417 0 0 1-2.833 0v-6.197a1.416 1.416 0 1 1 2.833 0z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M15 26.485a1.417 1.417 0 0 1-2.833 0v-6.197a1.417 1.417 0 1 1 2.833 0zm4.913 0a1.417 1.417 0 0 1-2.834 0v-6.197a1.418 1.418 0 0 1 2.834 0zM16.038 5.447c-3.445 0-6.282 2.621-6.66 5.991h13.32c-.378-3.37-3.213-5.991-6.66-5.991m-3.005 3.632a.554.554 0 1 1-.004-1.107.554.554 0 0 1 .004 1.107m6.022 0a.554.554 0 1 1-.002-1.107.554.554 0 0 1 .002 1.107"
    }
  )
);
var SvgAndroidFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var AndroidFilled_default = SvgAndroidFilled;

export { AndroidFilled_default as default };
